import {DashboardService} from "@/services/DashboardService";
import {KeyService} from "@/services/KeyService";

const state = {
  airReportStatusCounts: [],
  rsReportStatusCounts: [],
  airChartCounts:[],
  rsChartCounts:[],
  airSafetyAndHealthChartData : [],
  airSafetyAndHealthDataLoading : false,
  cmsRequestedOnBoardCrew : {},
  airSafetyAndHealthGraphDataLoading : true,
  injury_and_illnesses : [],
  loss_working_case : [],
  number_of_injury_part : [],
  number_of_illness_part : [],
  airSafetyAndHealthGraphChartDataPayload : [],
  crewNationalityList : [],
  vesselAccidentIncidentData : [],
  airYearlySummaryLoading : true,
  airYearlySummaryData : []
};


const mutations = {
  SET_AIR_REPORT_STATUS_COUNTS: (state, payload) => state.airReportStatusCounts = payload,
  SET_RS_REPORT_STATUS_COUNTS: (state, payload) => state.rsReportStatusCounts = payload,
  SET_AIR_CHART_COUNT: (state, payload) => state.airChartCounts = payload,
  SET_RS_CHART_COUNT: (state, payload) => state.rsChartCounts = payload,
  SET_AIR_SAFETY_AND_HEALTH_CHART_DATA: (state, payload) => state.airSafetyAndHealthChartData = payload,
  SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING: (state, payload) => state.airSafetyAndHealthDataLoading = payload,
  SET_AIR_SAFETY_AND_HEALTH_GRAPH_DATA_LOADING: (state, payload) => state.airSafetyAndHealthGraphDataLoading = payload,

  SET_CMS_REQUESTED_ON_BOARD_CREW: (state, payload) => {
    state.cmsRequestedOnBoardCrew[payload.key] = payload.value;
  },
  SET_AIR_SAFETY_AND_HEALTH_GRAPH_CHART_DATA: (state, payload) => {
    state[payload.key] = payload.value;
  },
  SET_AIR_SAFETY_AND_HEALTH_GRAPH_CHART_DATA_PAYLOAD: (state, payload) => state.airSafetyAndHealthGraphChartDataPayload = payload,
  SET_CREW_NATIONALITY_LIST: (state, payload) => state.crewNationalityList = payload,
  SET_ACCIDENT_INCIDENT_LOSS_REPORT: (state, payload) => state.vesselAccidentIncidentData = payload,
  SET_ACCIDENT_INCIDENT_YEARLY_LOADING: (state, payload) => state.airYearlySummaryLoading = payload,
  SET_ACCIDENT_INCIDENT_YEARLY_SUMMARY: (state, payload) => state.airYearlySummaryData = payload,
};


const actions = {
  async getAirReportStatusCounts({commit},params){
    const response= await DashboardService.getAirReportStatusCounts(params);
    if(response){
      commit('SET_AIR_REPORT_STATUS_COUNTS',response)
    }
  },
  async getRsReportStatusCounts({commit},params){
    const response= await DashboardService.getRsReportStatusCounts(params);
    if(response){
      commit('SET_RS_REPORT_STATUS_COUNTS',response)
    }
  },
  async getAccidentCharts({commit},params){
    const response= await DashboardService.getAccidentCharts(params);
    if(response){
      commit('SET_AIR_CHART_COUNT',response)
    }

    return response?.data?? false
  },

  async getRsCharts({commit},params){
    const response= await DashboardService.getRsCharts(params);
    if(response){
      commit('SET_RS_CHART_COUNT',response)
    }

    return response?.data?? false
  },

  async getAccidentSafetyAndHealthChartsData({commit},params) {
    const response= await DashboardService.getAccidentSafetyAndHealthChartsData(params);
    if(response){
      commit('SET_AIR_SAFETY_AND_HEALTH_CHART_DATA',response)
    }

    return response?.data?? false
  },
  async getCmsCrewNationality({commit},params) {
    const response= await KeyService.getCmsCrewNationality(params);
    if(response){
      commit('SET_CREW_NATIONALITY_LIST', response.data)
      commit('setPagination',response)
    }
  },
  async getDashboardAccidentIncidentLossReport({commit},params) {
    const response= await DashboardService.getDashboardAccidentIncidentLossReport(params);
    if(response){
      commit('SET_ACCIDENT_INCIDENT_LOSS_REPORT',response)
    }
  },
  async getDashboardAIYearlySummary({commit},params) {
    const response= await DashboardService.getDashboardAIYearlySummary(params);
    if(response){
      commit('SET_ACCIDENT_INCIDENT_YEARLY_SUMMARY',response)

      return response;
    }
  }
};


const getters = {
  airReportStatusCounts: state => state.airReportStatusCounts,
  rsReportStatusCounts: state => state.rsReportStatusCounts,
  airChartCounts: state => state.airChartCounts,
  rsChartCounts: state => state.rsChartCounts,
  airSafetyAndHealthChartData: state => state.airSafetyAndHealthChartData,
  airSafetyAndHealthDataLoading: state => state.airSafetyAndHealthDataLoading,
  airSafetyAndHealthGraphDataLoading: state => state.airSafetyAndHealthGraphDataLoading,
  cmsRequestedOnBoardCrew: state => state.cmsRequestedOnBoardCrew,
  airSafetyAndHealthGraphChartDataPayload: state => state.airSafetyAndHealthGraphChartDataPayload,
  injury_and_illnesses: state => state.injury_and_illnesses,
  loss_working_case: state => state.loss_working_case,
  number_of_injury_part: state => state.number_of_injury_part,
  number_of_illness_part: state => state.number_of_illness_part,
  crewNationalityList: state => state.crewNationalityList,
  vesselAccidentIncidentData: state => state.vesselAccidentIncidentData,
  airYearlySummaryLoading: state => state.airYearlySummaryLoading,
  airYearlySummaryData: state => state.airYearlySummaryData,
};

export default {state, actions, mutations, getters};
